import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import SubsidySection from './components/SubsidySection';
import WhyUsSection from './components/WhyUsSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';
import StickyButtons from './components/StickyButtons';
import AdminPanel from './pages/AdminPanel';

function App() {
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <>
              <Header onCtaClick={scrollToForm} />
              <HeroSection onCtaClick={scrollToForm} />
              <ProblemSection />
              <SolutionSection />
              <SubsidySection onCtaClick={scrollToForm} />
              <WhyUsSection />
              <GallerySection />
              <TestimonialsSection />
              <ProcessSection />
              <FAQSection />
              <div id="lead-form">
                <LeadForm />
              </div>
              <Footer />
              <StickyButtons />
            </>
          } />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;